__turbopack_context__.v({
  "bg": "index-module-scss-module__pcW0ca__bg",
});
